<script>
import CommonMixin from './CommonMixin';
import LauncherOutlet from '@/launcher/components/routes/VR/outlet/LauncherOutlet.vue';

export default {
  name: 'GamesSearchRoute',
  mixins: [CommonMixin],
  components: {
    LauncherOutlet,
  },
  beforeRouteEnter (to, from, next) {
    return next((vm) => {
      if (from.meta.realName !== 'games-show') {
        vm.$store.dispatch('clearSearch');
      }
    });
  },
};
</script>
<template lang="pug">
div.flex.flex-column
  GamesSearchBoxConnected.mb3(style="height: 256px;")
  KeyboardBoxConnected.w-80.center

</template>

<style scoped>

</style>
